/*** IMPORTS FROM imports-loader ***/
var define = false;

const Globalize = require('globalize');

const supplemental = {
  // from /node_modules/cldr-data/supplemental/currencyData.json
  supplemental: {
    currencyData: {
      fractions: {
        DEFAULT: {
          _rounding: '0',
          _digits: '2'
        }
      }
    }
  }
};


// Before we can use Globalize, we need to feed it on the appropriate I18n content (Unicode CLDR).
// Read Requirements on Getting Started on the root's README.md for more information.
Globalize.load(
  // Core
  require('cldr-data/supplemental/likelySubtags'),
  require('cldr-data/main/en/numbers'),
  // require( "cldr-data/main/zh-Hant/numbers" ),
  supplemental,
  // NOTE: We don't need all the currency data, just USD
  require('i18n/en/currencies'),
  // require( "i18n/zh-Hant/currencies" ),
  // require( "cldr-data/supplemental/currencyData" ),

  // require( "cldr-data/main/en/ca-gregorian" ),
  // require( "cldr-data/main/en/dateFields" ),
  require('cldr-data/supplemental/plurals')
  // require( "cldr-data/supplemental/timeData" ),
  // require( "cldr-data/supplemental/weekData" )
);
// Globalize.loadMessages(require('i18n/en/messages'));

// Set "en" as our default locale.
Globalize.locale('en');

window.Globalize = Globalize;

module.exports = Globalize;

